import React, { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ExpandOrderButton from '../Order/ExpandOrderButton';

const headerStyle = css`
  background-color: #faf9f8;
  color: #2a2928;
  padding: 0.25rem 1rem;
  display: flex;
  align-items: center;

  & span {
    flex: 1;
    font-weight: 600;
    font-size: 0.875rem;
  }
`;

const closeIconStyle = css`
  cursor: pointer;
  border: none;
  width: fit-content;
`;

const contentStyle = (height: number, isOpen: boolean) => {
  return css`
    max-height: ${isOpen ? `${height}px` : '0px'};
    transition: max-height 0.3s ease-out;
    overflow: hidden;
  `;
};

const iconContainer = css`
  min-width: 1rem;
  min-height: 1rem;
`;

const Accordion = (props) => {
  const title = get(props, 'title');
  const open = get(props, 'open', false);
  const icon = get(props, 'icon');
  const onClose = get(props, 'onClose', () => {});
  const onExpand = get(props, 'onExpand', () => {});
  const children = get(props, 'children');
  const className = get(props, 'className');
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(get(contentRef, 'current.scrollHeight', 0));
    }
  }, [isOpen, children]);

  useEffect(() => {
    if (isOpen) {
      onExpand();
    } else {
      onClose();
    }
  }, [isOpen]);

  return (
    <div className={className}>
      <div className={headerStyle}>
        <div className={iconContainer}>{icon}</div>
        <span>{title}</span>
        <div className={closeIconStyle}>
          <ExpandOrderButton expanded={isOpen} onChange={toggleAccordion} />
        </div>
      </div>
      <div className={contentStyle(height, isOpen)} ref={contentRef}>
        {children}
      </div>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  onClose: PropTypes.func,
  onExpand: PropTypes.func,
  children: PropTypes.any,
  headerStyles: PropTypes.string,
  open: PropTypes.bool,
};

export default Accordion;
